<template>
  <div>
    <div class="totals">
      <div>
        <div class="w3-center dark w3-round">
          <div class="w3-padding">
            <b>{{state.admin.global.invoices.unpaid}}</b>
          </div>
          <footer class="w3-orange">Unpaid</footer>
        </div>
      </div>
      <div>
        <div class="w3-center dark w3-round">
          <div class="w3-padding">
            <b>{{state.admin.global.invoices.overdue}}</b>
          </div>
          <footer class="w3-red">Overdue</footer>
        </div>
      </div>
      <div>
        <div class="w3-center dark w3-round">
          <div class="w3-padding">
            <b>{{state.admin.global.invoices.paid}}</b>
          </div>
          <footer class="w3-green">Paid</footer>
        </div>
      </div>
      <div>
        <div class="w3-center dark w3-round">
          <div class="w3-padding">
            <b>{{state.admin.global.invoices.total}}</b>
          </div>
          <footer class="w3-blue">Total</footer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dataStore from '@/dataStore';

export default {
  name: 'totals',
  data() {
    return {
      state: dataStore.state
    }
  }
}
</script>
<style scoped>
  footer {border-radius: 0 0 4px 4px;}
</style>


// WEBPACK FOOTER //
// src/system/molecules/totals.vue